import {TabStatusEnum} from '../../../../../../shared/tabs/tab-status.model';

export function aggregateTabStatus(statuses: TabStatusEnum[]): TabStatusEnum {
  if (statuses.length === 0) {
    return TabStatusEnum.NOT_STARTED;
  }

  if (statuses.every((status) => status === TabStatusEnum.COMPLETED)) {
    return TabStatusEnum.COMPLETED;
  }

  if (statuses.some((status) => status !== TabStatusEnum.NOT_STARTED)) {
    return TabStatusEnum.IN_PROGRESS;
  }

  return TabStatusEnum.NOT_STARTED;
}

export function aggregateSummaryTabStatus(statuses: TabStatusEnum[]): TabStatusEnum {
  if (statuses.includes(TabStatusEnum.COMPLETED)) {
    return TabStatusEnum.COMPLETED;
  }

  if (statuses.some((status) => status !== TabStatusEnum.NOT_STARTED)) {
    return TabStatusEnum.IN_PROGRESS;
  }

  return TabStatusEnum.NOT_STARTED;
}
